import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Component({
  selector: 'spb-primary-input',
  templateUrl: './primary-input.component.html',
})
export class PrimaryInputComponent implements OnInit {
  @HostBinding('class.spb-primary-input') hostBaseClass = true;
  @Input() inputType = 'text';
  @Input() parentForm: FormGroup;
  @Input() inputValue = '';
  @Input() placeholder = '';
  @Input() inputLabel: string;
  @Input() errorMessages: any;
  @Input() inputIcon: string;
  @Input() isRequiredField: boolean;
  @Input() controlName: any;
  @Output() emitChangeEvent = new EventEmitter();
  @Output() emitFocusEvent = new EventEmitter();
  @Output() emitBlurEvent = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }
}
